import { ChainId } from '@nominex/nomiswap-sdk'

export default {
  farmingHelper: {
    1: '0x353194F789a302Cba937a1D578a20b80bD2610a5',
    10: '',
    56: '0xc996Cf5D764c6A29Ef1ccbb9865133f9bbd7c80E',
    100: '',
    137: '0x9c071AdD402cDAEDBD13a3f3A993AF99576922dD',
    42161: '',
    43114: '',
  },
  multicall: {
    1: '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
    10: '0xcA11bde05977b3631167028862bE2a173976CA11',
    56: '0xfF6FD90A470Aaa0c1B8A54681746b07AcdFedc9B',
    100: '0xcA11bde05977b3631167028862bE2a173976CA11',
    137: '0x11ce4B23bD875D7F5C6a31084f55fDe1e9A87507',
    42161: '0x842eC2c7D803033Edf55E478F461FC547Bc54EB2',
    43114: '0xb14067B3C160E378DeEAFA8c0D03FF97Fbf0C408',
  },
  reinvest: {
    1: '',
    10: '',
    56: '0xB56629982e05B4E2b7ecF94268A40E9Fb93b4EB6',
    100: '',
    137: '',
    42161: '',
    43114: '',
  },
  stableSwapMigrator: {
    1: '',
    10: '',
    56: '0xFa88112318C4EBb789a66D8B27f1B62A605f41CE',
    100: '',
    137: '',
    42161: '',
    43114: '',
  },
  stakingRouter: {
    1: '',
    10: '',
    56: '0x99b674Ba03E896D952983908DbA8D7b560FB10d5',
    100: '',
    137: '0xBD573bF9aAFC9CeA5Dd06118F6773C3986587387',
    42161: '',
    43114: '',
  },
  poolFactory: {
    1: '',
    10: '',
    56: '0xe2FD4443d855F6bd479aec885460cbc09788Fac4',
    100: '',
    137: '',
    42161: '',
    43114: '',
  },
  launchpoolMigrator: {
    1: '',
    10: '',
    56: '0x63A1eaC995a9f490b9c24570a238281aA7e2fF6e',
    100: '',
    137: '',
    42161: '',
    43114: '',
  },
  nomiswapEPCSFactory: {
    [ChainId.ETHEREUM]: '0x143527Dc7703d818Ea96aE326824Dd60B9Cc8875',
    [ChainId.OPTIMISM]: '0x143527Dc7703d818Ea96aE326824Dd60B9Cc8875',
    [ChainId.BSC]: '0x6d932465963C10B108D4aa9C72a59A1ca5Ce0c50',
    [ChainId.GNOSIS]: '0x143527Dc7703d818Ea96aE326824Dd60B9Cc8875',
    [ChainId.MATIC]: '0x143527Dc7703d818Ea96aE326824Dd60B9Cc8875',
    [ChainId.ARBITRUM]: '0x143527Dc7703d818Ea96aE326824Dd60B9Cc8875',
    [ChainId.AVALANCHE]: '0x143527Dc7703d818Ea96aE326824Dd60B9Cc8875',
  },
  nomiswapEPCSRouter: {
    [ChainId.ETHEREUM]: '0xAA0A28c7881F1f3462c9Af673a79C874Cc424C3c',
    [ChainId.OPTIMISM]: '0xAA0A28c7881F1f3462c9Af673a79C874Cc424C3c',
    [ChainId.BSC]: '0x8f7A246CDc1E47ACDE76613E8bBD372e569bE98E',
    [ChainId.GNOSIS]: '0xAA0A28c7881F1f3462c9Af673a79C874Cc424C3c',
    [ChainId.MATIC]: '0xAA0A28c7881F1f3462c9Af673a79C874Cc424C3c',
    [ChainId.ARBITRUM]: '0x894dEB5840E146A1c823F7e0381F1B783feaD342',
    [ChainId.AVALANCHE]: '0xAA0A28c7881F1f3462c9Af673a79C874Cc424C3c',
  },
}
